import { render } from "./CusImage.vue?vue&type=template&id=ac128be2"
const script = {}

import exportComponent from "/Users/apple/Documents/yang/wms-image/wms-image-pc/Commodity_Wms_Pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__